/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';

export interface SystemDateTimeIconProps {
  color?: string;
  iconSize?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) System Date Time Icon component.
 */
export const SystemDateTimeIcon = ({iconSize = 14, color = dlsColor('grey1')}: SystemDateTimeIconProps) => {
  return (
    <ThemeIconProvider name='SystemDateTimeIcon' size={iconSize} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.71423 5V7.65143L8.54852 8.99429" stroke={color} strokeWidth="1.35" strokeMiterlimit="10" strokeLinecap="round"/>
        <circle cx="7" cy="7" r="6" stroke={color} strokeWidth="1.35"/>
      </svg>
    )} />
  );
};
